import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoaderService } from '@app/core/loader.service';
import { ScrollService } from '@app/core/scroll.service';
import { listMyKsuiteAuthorizedCountries } from '@app/models/ikme';
import { UtilsService } from '@app/shared/utils.service';
import { SetLangSuccessful, UpdateItem } from '@app/store/actions/cart.action';
import { CartState } from '@app/store/state/cart.state';
import { NotificationService } from '@infomaniak/angular-common';
import { translate } from '@ngneat/transloco';
import { Actions, ofActionCompleted, ofActionSuccessful, Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';

import { setCurrentServiceID } from '../wc-service-helper';
import { DriveService } from './drive.service';
import { IDrivePackDescriptionList } from '@app/order/selection/drive/drive.interfaces';

@Component({
  selector: 'app-drive',
  templateUrl: './drive.component.html',
  styleUrls: ['./drive.component.scss'],
})
export class DriveComponent implements OnInit, OnDestroy {
  urlEndPoint = window.location.href;
  @ViewChild('drivePrefixEl') drivePrefixEl: ElementRef;
  @ViewChild('driveForm')
  driveForm: NgForm;
  myItem: any;
  myConfiguration: any;
  staredOption: any;
  myPrices: any;
  myPromo: any;
  conf: any;
  pack: any;
  loading = false;
  currency = window['CONST_CURRENCY'].label;
  priceByPeriod: any[] = [];
  canTrial = false;
  forceTrial = false;
  offer: string;
  timer: any;
  changingNbUser = false;

  @Select(CartState.item)
  item$: Observable<any>;

  @Select(CartState.status)
  status$: Observable<any>;

  @Select(CartState.accounts)
  accounts$: Observable<any>;

  isB2B = false;

  updater: any;
  nbUserUpdater: any;

  forcedTrial = false;

  initOnce = false;
  selectedItem: any = null;
  once = false;
  childIndex = 0;
  amount = 0;
  startPress = 0;
  lastX = 0;
  minimumPrice: number;
  packDescription = new Map<number, IDrivePackDescriptionList[]>();
  packSettings = new Map<number, string[]>();
  callbackNbUserError: any;
  displaySlideshow = false;

  indexStep1: number;
  indexStep2: number;
  indexStep5: number;

  nb_user_value = 2;
  nb_jour_beta = 180;
  suffix_name = '';

  defaultDrivePrefix = 'DRIVE';

  matSliderConfig: {
    min: number;
    max: number;
    step: number;
  } = null;

  matSliderValue = 0;

  matInputValue = 0;

  matInputConfig: {
    min: number;
    max: number;
  } = null;

  changingDiskSize = false;
  changingInput = false;

  public configStep1: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    loop: false,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: {
      nextEl: '.next-step1',
      prevEl: '.prev-step1',
    },
    pagination: false,
    threshold: 20,
  };

  public configStep2: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    updateOnWindowResize: true,
    loop: false,
    threshold: 20,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: {
      nextEl: '.next-step2',
      prevEl: '.prev-step2',
    },
    pagination: false,
    normalizeSlideIndex: true,
    watchOverflow: true,
  };

  public configStep3: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 4,
    loop: false,
    breakpoints: {
      // when window width is <= px
      760: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
      1366: {
        slidesPerView: 3,
      },
    },
    threshold: 20,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: {
      nextEl: '.next-step3',
      prevEl: '.prev-step3',
    },
    pagination: false,
  };

  timeout: any;

  sub: Subscription;

  public isMobile: boolean;
  public isPhone: boolean;

  @ViewChild(SwiperDirective)
  directiveRef?: SwiperDirective;

  private onDestroy$ = new Subject<boolean>();

  constructor(
    private store: Store,
    private utils: UtilsService,
    public breakpointObserver: BreakpointObserver,
    private notificationService: NotificationService,
    private scrollService: ScrollService,
    private loaderService: LoaderService,
    private driveService: DriveService,
    private actions: Actions
  ) {
    this.setPackInfo();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.showSlideshow();
  }

  showSlideshow() {
    if (this.utils.responsiveHelper('sm')) {
      this.displaySlideshow = false;
    } else {
      this.displaySlideshow = true;
    }
  }

  ngOnInit() {
    setCurrentServiceID(40);
    this.urlEndPoint = window.location.href;
    this.showSlideshow();
    this.loading = true;
    if (window['CONST_USER']) {
      // If user is log, we check if the curr account is partner/client
      this.accounts$.pipe(takeUntil(this.onDestroy$)).subscribe((accounts) => {
        if (accounts?.length >= 1) {
          this.isB2B = accounts.find((acc) => acc.id === window['CURRENT_ACCOUNT'].id)?.is_customer;
        }
      });
    }
    this.item$.pipe(takeUntil(this.onDestroy$)).subscribe((item: any) => {
      if (item) {
        if (item.validation && item.validation.errors) {
          if (item.validation.errors['can_beta']) {
            if (
              item.validation.errors['can_beta'] &&
              item.validation.errors['can_beta'].indexOf('validation.unregistered') >= 0
            ) {
              window.location.assign('/error?custom_error=drive_unregistered');
            }
            if (
              item.validation.errors['can_beta'] &&
              item.validation.errors['can_beta'].indexOf('validation.quota_reached') >= 0
            ) {
              window.location.assign('/error?custom_error=drive_quota_reached');
            }
          }
        }
        const configuration = item.configuration;
        this.nb_jour_beta = configuration.setup.trial_period || 90;
        this.suffix_name = configuration.setup.suffix_name || '';
        this.priceByPeriod = item.configuration.prices.dynamic ? configuration.prices.dynamic.period : [];
        this.defaultDrivePrefix = configuration.setup.default_name || translate('Nom') + ' :';
        this.conf = configuration;
        this.canTrial = configuration.setup.can_trial;
        this.forceTrial = configuration.setup.force_trial;
        this.offer = configuration.setup.offer;
        this.myPrices = configuration.prices.attributes;
        this.minimumPrice = item.configuration.prices.dynamic.minimum.period.monthly.incl_vat;
        this.myPromo = configuration.prices.promos;
        this.staredOption = configuration.setup.stared_options;
        this.myConfiguration = configuration.validators;
        this.myItem = {
          attributes: {
            ...cloneDeep(item.attributes),
          },
          setup: cloneDeep(item.setup),
        };
        console.log('my item', this.myItem);

        if (this.myConfiguration.disk_size && this.myConfiguration.disk_size.values) {
          this.matSliderConfig = {
            min: this.myConfiguration.disk_size.values[0],
            max: this.myConfiguration.disk_size.values[this.myConfiguration.disk_size.values.length - 1],
            step: this.myConfiguration.disk_size.values[1] - this.myConfiguration.disk_size.values[0],
          };
        }
        if (this.myConfiguration.user_nb && this.myConfiguration.user_nb.min) {
          this.matInputConfig = {
            min: this.myConfiguration.user_nb.min || null,
            max: this.myConfiguration.user_nb.max || null,
          };
        }

        // si l'un des deux block 'optionnels' ont des valeurs, on les show a l'init
        if (this.initOnce === false) {
          this.initOnce = true;
          if (this.myItem.attributes.disk_size) {
            this.matSliderValue = this.myItem.attributes.disk_size;
          } else if (this.matSliderConfig && this.matSliderConfig.min) {
            this.matSliderValue = this.matSliderConfig.min;
          }
          if (this.myItem.attributes.user_nb) {
            this.matInputValue = this.myItem.attributes.user_nb;
          } else if (this.matInputConfig && this.matInputConfig.min) {
            this.matInputValue = this.matInputConfig.min;
          }
          this.indexStep1 = this.myItem.attributes.trial === false ? 1 : 0;
          if (this.canTrial) {
            this.myItem.attributes.trial = item.attributes.pack_id ? item.attributes.trial : 1;
          } else {
            this.myItem.attributes.trial = 0;
          }
          if (!this.offer && !this.isB2B && listMyKsuiteAuthorizedCountries.includes(window['COUNTRY'].toLowerCase())) {
            // free mail filtered countries list
            this.pack = [
              {
                id: 0,
                name: 'Free',
              },
              ...configuration.setup.informations.pack,
            ];
          } else {
            this.pack = [...configuration.setup.informations.pack];
          }
        }
        this.selectedItem = this.myItem.disk_size;
        this.nb_user_value = this.myItem.attributes.user_nb
          ? this.myItem.attributes.user_nb
          : this.myConfiguration.user_nb
          ? this.myConfiguration.user_nb.min || 2
          : 2 || 2;

        this.configStep2 = {
          // set the conf again to void glitch swiper grid ??
          direction: 'horizontal',
          slidesPerView: 'auto',
          updateOnWindowResize: true,
          loop: false,
          threshold: 20,
          keyboard: true,
          mousewheel: false,
          scrollbar: false,
          navigation: {
            nextEl: '.next-step2',
            prevEl: '.prev-step2',
          },
          pagination: false,
          normalizeSlideIndex: true,
          watchOverflow: true,
        };
        this.loading = false;
      }

      this.actions.pipe(ofActionCompleted(SetLangSuccessful)).subscribe((x) => {
        this.setPackInfo();
      });
    });

    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium]).subscribe((result) => {
      if (result.breakpoints[Breakpoints.XSmall]) {
        this.isPhone = true;
        this.isMobile = true;
      } else if (result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.Medium]) {
        this.isMobile = true;
        this.isPhone = false;
      } else {
        this.isMobile = false;
        this.isPhone = false;
      }
    });

    if (!this.updater) {
      Observable.create((observer: any) => {
        this.updater = observer;
      })
        // .pipe(debounceTime(300)) // wait 300ms after the last event before emitting last event
        .pipe(takeUntil(this.onDestroy$))
        .pipe(tap(() => (this.loading = true)))
        .subscribe((x: any) => {
          if (x) {
            this.store
              .dispatch(new UpdateItem(x))
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(
                () => {
                  this.loading = false;
                },
                () => {
                  this.loading = false;
                },
                () => {
                  this.loading = false;
                }
              )
              .add(() => {
                this.loading = false;
              });
          }
        })
        .add(() => {
          this.loading = false;
        });
    }
    if (!this.nbUserUpdater) {
      Observable.create((observer: any) => {
        this.nbUserUpdater = observer;
      })
        .pipe(debounceTime(1000)) // wait 1000ms after the last event before emitting last event
        .pipe(takeUntil(this.onDestroy$))
        .pipe(tap(() => (this.loading = true)))
        .subscribe((x: any) => {
          if (x) {
            this.store
              .dispatch(new UpdateItem(x))
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(
                () => {
                  this.loading = false;
                },
                () => {
                  this.loading = false;
                },
                () => {
                  this.loading = false;
                }
              )
              .add(() => {
                this.loading = false;
              });
          }
        })
        .add(() => {
          this.loading = false;
        });
    }
  }

  updateMyItem(nbUser = false, callback1 = true, forceUpdater = false) {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (nbUser) {
      this.myItem.attributes.user_nb = +this.nb_user_value;
      this.myItem.attributes.pack_id = 3;
    }
    const myItem = cloneDeep(this.myItem);
    Object.keys(myItem.attributes).forEach((key) => myItem.attributes[key] == null && delete myItem.attributes[key]);
    if (callback1) {
      const callback = () => {
        setTimeout(() => {
          this.focus(true);
        });
      };
      this.sub = this.actions.pipe(ofActionSuccessful(UpdateItem), takeUntil(this.onDestroy$)).subscribe(() => {
        callback();
      });
    }

    if (nbUser || forceUpdater) {
      this.nbUserUpdater.next(myItem);
    } else {
      this.updater.next(myItem);
    }
  }

  focus(scroll = false) {
    if (scroll) {
      this.scroll('step5');
    } else if (this.drivePrefixEl && this.drivePrefixEl.nativeElement) {
      this.drivePrefixEl.nativeElement.focus();
    }
  }

  getPrice(category: string, value: string | number, fixed = false): any {
    try {
      if (category === 'period') {
        const myPeriod = this.priceByPeriod.find((x) => x.unit === value) as any;
        return myPeriod && myPeriod.prices
          ? fixed
            ? { amountVAT: myPeriod.prices.fixed.incl_vat, amountNoVAT: myPeriod.prices.fixed.excl_vat }
            : {
                amountVAT: myPeriod.prices.period.monthly.incl_vat,
                amountNoVAT: myPeriod.prices.period.monthly.excl_vat,
              }
          : 'N/D';
      }
      if (category === 'disk_size') {
        console.warn();
        const myPeriod = this.conf.prices.attributes.disk_size[value] as any;
        if (!myPeriod) {
          return null;
        }
        return { amountVAT: myPeriod.incl_vat, amountNoVAT: myPeriod.excl_vat };
      }
      if (category === 'user_nb') {
        if (+value === 0) {
          return { amountVAT: 0, amountNoVAT: 0 };
        }
        const myPeriod = this.conf.prices.attributes.user_nb;
        if (!myPeriod[value]) {
          return { amountVAT: null, amountNoVAT: null };
        }
        return {
          amountVAT: myPeriod[value].prices.period.monthly.incl_vat,
          amountNoVAT: myPeriod[value].prices.period.monthly.excl_vat,
        };
      }
      if (category === 'pack') {
        const packId = value;
        const packPrices = this.myPrices['pack'][packId] as IPricesPack;
        const selectedPackPrice = packPrices.monthly;

        if (selectedPackPrice && selectedPackPrice.prices) {
          return fixed
            ? {
                amountVAT: selectedPackPrice.prices.fixed.incl_vat,
                amountNoVAT: selectedPackPrice.prices.fixed.excl_vat,
              }
            : {
                amountVAT: selectedPackPrice.prices.period.monthly.incl_vat,
                amountNoVAT: selectedPackPrice.prices.period.monthly.excl_vat,
              };
        }
        return 'N/D';
      }

      const categoryPrices = this.myPrices[category].find((x: any) => x.unit === value).prices;
      return fixed
        ? { amountVAT: categoryPrices.fixed.incl_vat, amountNoVAT: categoryPrices.fixed.excl_vat }
        : {
            amountVAT: categoryPrices.period.monthly.incl_vat,
            amountNoVAT: categoryPrices.period.monthly.excl_vat,
          };
    } catch (e) {
      console.error(e);
      return { amountVAT: null, amountNoVAT: null };
    }
  }

  isStared(category: string, value: string) {
    return (
      this.staredOption && this.staredOption[category] && this.staredOption[category].find((x: any) => x.unit === value)
    );
  }

  getPromo(category: string, value: string | number) {
    if (!(this.myPromo && this.myPromo[category])) {
      return;
    }
    const promo = this.myPromo[category].find((x: any) => x.unit === value);
    return promo ? promo.label : null;
  }

  setPeriod(value) {
    this.myItem.attributes.period = value;
    this.updateMyItem(false, false);
  }

  setName(input) {
    this.myItem.attributes.prefix_name = input.value || input.placeholder;
    this.updateMyItem();
  }

  scroll(id: string) {
    this.scrollService.scrollTo({ id, waitForLoader: this.loaderService.item.isLoading$ });
  }

  scrollWizard(currentStep: 'step2' | 'step3' | 'step4' | 'step5', packId?: 1 | 2 | 3) {
    packId = packId || this.myItem.attributes.pack_id;
    if (currentStep === 'step2') {
      if (packId === 1) {
        this.scroll('step5');
      } else if (packId === 3) {
        this.scroll('step3');
      } else {
        this.scroll('step4');
      }
    } else if (currentStep === 'step3') {
      this.scroll('step4');
    } else if (currentStep === 'step4') {
      this.scroll('step5');
    }
  }

  resetDrive() {
    this.myItem.attributes.pack_id = null;
    this.myItem.attributes.disk_size = null;
    this.myItem.attributes.nb_user = null;
    this.initOnce = false;
  }

  setPackInfo(): void {
    [0, 1, 2, 3].forEach((packId) => {
      this.packSettings.set(packId, this.driveService.getPackSettings(packId));
      this.packDescription.set(packId, this.driveService.getPackDescription(packId));
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  onDiskSizeChange(event) {
    this.matSliderValue = event.value;
  }

  incrementDiskSize(index) {
    if (
      (this.matSliderValue !== this.matSliderConfig.min || index === 1) &&
      (this.matSliderValue !== this.matSliderConfig.max || index === -1)
    ) {
      this.changingDiskSize = true;
      const currentIndex = this.myConfiguration.disk_size.values.indexOf(this.matSliderValue);
      this.matSliderValue = this.myConfiguration.disk_size.values[currentIndex + index];
      this.myItem.attributes.disk_size = this.matSliderValue;
      this.updateMyItem(false, null, true);
    }
  }

  incrementUserNb(value) {
    if (
      (this.matInputValue !== this.matInputConfig.min || value === 1) &&
      (this.matInputValue !== this.matInputConfig.max || value === -1)
    ) {
      this.changingInput = true;
      this.matInputValue = +this.matInputValue + value;
      if (this.matInputValue <= this.matInputConfig.max) {
        this.myItem.attributes.user_nb = this.matInputValue;
        this.updateMyItem(false, false, true);
      }
    }
  }

  getLabelDays(num: number) {
    const an = translate('an');
    const ans = translate('ans');
    const jours = translate('jours');

    return num === 365 ? `1 ${an}` : num > 365 ? `${num / 365} ${ans}` : `${num} ${jours}`;
  }

  getPeriodClasses(period: string) {
    const values =
      typeof this.myConfiguration?.['period']?.values === 'string'
        ? [this.myConfiguration?.['period']?.values]
        : this.myConfiguration?.['period']?.values;
    if (values.includes(period)) {
      const classes = ['periodselector__btn'];
      const index = values.indexOf(period);
      if (values.length === 1) {
        classes.push('periodselector__btn--alone');
      } else if (index === 0) {
        classes.push('periodselector__btn--left');
      } else if (index === values.length - 1) {
        classes.push('periodselector__btn--right');
      } else {
        classes.push('periodselector__btn--middle');
      }
      return classes;
    } else {
      return ['hidden'];
    }
  }

  getDiskSizeLabel(value: number) {
    return value / 1000;
  }

  toNumber(bool: boolean): number {
    if (bool === undefined || bool === null) {
      return 0;
    }
    return +bool;
  }

  goToMyKsuite() {
    window.location.assign('signup/ikdrive');
  }
}

interface IPricesPackPeriod {
  pack_id: string;
  prices: {
    period: {
      monthly: {
        excl_vat: number;
        incl_vat: number;
        vat: number;
      };
    };
    fixed: {
      excl_vat: number;
      incl_vat: number;
      vat: number;
    };
    setup: {
      excl_vat: number;
      incl_vat: number;
      vat: number;
    };
  };
}

interface IPricesPack {
  annual: IPricesPackPeriod;
  monthly: IPricesPackPeriod;
}
